module.exports = "<div class=\"quoteBorder mx-auto\">\n  <p>&quot;{{ quote }}&quot;</p>\n  <p>{{ name }}</p>\n</div>\n"